import { useMatches } from 'react-router-dom';

// Walk the active route matches from deepest to shallowest and return the
// first parent loader data found.
export default () => {
  const matches = useMatches();

  for (let i = matches.length - 1; i >= 0; --i) {
    if (matches[i].data) {
      return matches[i].data;
    }
  }

  return {};
}